
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifecycle-studio/dynamic-content",
      function () {
        return require("private-next-pages/lifecycle-studio/dynamic-content.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifecycle-studio/dynamic-content"])
      });
    }
  